import { useQuery } from "@tanstack/react-query";

import { courtsApi } from "@/api";
import { QueryKey } from "@/query/Query";

export function useAvailableDistricts(excludeCourtId?: string) {
  const { data, isLoading } = useQuery({
    queryKey: [QueryKey.AvailableCourtDistricts, excludeCourtId ?? null],
    queryFn: () => courtsApi.getAvailableCourtDistricts({ excludeCourtId }),
  });

  return { availableDistricts: data ?? [], isLoading };
}
